import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import strings from '@/language/Swedish';
import { AdsTableType, SalesRefTableType } from '@/types/dataTypes';
import { defaultSoldTableRealEstateColumns, defaultSoldTableAdInfoColumns, defaultSoldTableSaleInfoColumnsExcel } from '@/context/SoldDefault';
import {
  modifyValueBasedOnKeyForExcel,
} from '@/helpers';
import { defaultAdsTableColumnsExcel } from '@/context/AdsDefault';
import { ColumnEnum } from '@/enums';

function camelCase(key: string): string {
  if (!key.includes("_")) {
    return key;
  }
  return key
    .replace(/_([a-z])/g, (_: any, letter: string) => letter.toUpperCase())
    .replace(/-([a-z])/g, (_: any, letter: string) => letter.toUpperCase());
}

function getColumnName(name: string, isAd?: boolean) {
  let key = name;
  if (isAd && key == ColumnEnum.priceSqm) {
    key = ColumnEnum.adPriceSqm;
  }
  return strings.table.columns[camelCase(key) as keyof typeof strings.table.columns] || key;
}
function addWorkSheet(workbook: any, table: SalesRefTableType[] | AdsTableType[], defaults: any, sheetName: string, isAd?: boolean) {

  const worksheet = workbook.addWorksheet(sheetName);
  const headers = defaults.filter((e) => e.isVisible).map((k) => k.id);
  worksheet.addRow(headers.map((name: string) => getColumnName(name, isAd)));
  for (let i = 0; i !== table.length; i++) {
    const newData: string[] = [];
    headers.forEach((element:string) => {
      const modifiedElement = table[i][camelCase(element) as keyof (SalesRefTableType | AdsTableType)] || table[i][element as keyof (SalesRefTableType | AdsTableType)];
      newData.push(modifiedElement as string);
    });
    worksheet.addRow(Object.values(newData).map((i, index) => modifyValueBasedOnKeyForExcel(i, headers[index]) || ''));
  }
}


export const exportSoldToExcel = async (columns: SalesRefTableType[], fileName: string) => {
  const workbook = new ExcelJS.Workbook();

  addWorkSheet(workbook, columns, defaultSoldTableSaleInfoColumnsExcel, strings.data.salesInfo)
  addWorkSheet(workbook, columns, defaultSoldTableAdInfoColumns, strings.data.adInfo)
  addWorkSheet(workbook, columns, defaultSoldTableRealEstateColumns, strings.data.realEstateInfo)

  const buffer = await workbook.xlsx.writeBuffer();

  saveAs(new Blob([buffer]), `${fileName}.xlsx`);
};

export const exportToExcelAds = async (table: AdsTableType[], fileName: string) => {
  const workbook = new ExcelJS.Workbook();
  addWorkSheet(workbook, table, defaultAdsTableColumnsExcel, strings.navigation.ads, true)
  const buffer = await workbook.xlsx.writeBuffer();

  saveAs(new Blob([buffer]), `${fileName}.xlsx`);
};
